<div class="container-fluid wrapper-page">
    <div class="page-head">
        <h5 class="header-title text-primary pl-2 pl-md-1">PAST APPOINTMENTS</h5>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <p class="text-center font-size-15 font-weight-400">
                                ENTER PATIENT NAME OR APPOINTMENT DATE
                            </p>
                        </div>
                    </div>
                    <form [formGroup]="findAppointmentForm">
                        <div class="row ">
                            <div class="col-md-1"></div>
                            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                <input type="text" class="form-control select" placeholder="Patient Name" name="patName"
                                    formControlName="patName" />
                            </div>
                            <div class="col d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                <input class="form-control" placeholder="From Date(DD/MM/YYYY)" name="fromDate"
                                    [maxDate]="maxDate" ngbDatepicker #fromDate="ngbDatepicker"
                                    data-date-inline-picker="true" id="fromDate" formControlName="fromDate" />
                                <div class="input-group-append">
                                    <button
                                        class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                                        (click)="fromDate.toggle()" type="button" id="fromDate">
                                        <span class="fa fa-calendar"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="col d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                <input class="form-control" placeholder="To Date(DD/MM/YYYY)" name="toDate"
                                    [maxDate]="maxDate" ngbDatepicker #toDate="ngbDatepicker"
                                    data-date-inline-picker="true" id="toDate" formControlName="toDate" />
                                <div class="input-group-append">
                                    <button
                                        class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                                        (click)="toDate.toggle()" type="button" id="toDate">
                                        <span class="fa fa-calendar"></span>
                                    </button>
                                </div>
                            </div>
                        </div>


                        <!-- Vinoth Changes new deploy -->
                        <div class="row mt-5" *ngIf="srvdet?.length">
                            <div class="col-md-3" *ngFor="let web of srvdet">
                                <div class=" m-b-20">
                                    <div class="row">
                                        <div class="col-md-4"></div>
                                        <div class="col-lg-8">

                                            <div class="card m-b-30 border-0 form-group">

                                                <div class="row">
                                                    <label>
                                                        <input type="checkbox" [value]="web.service_id"
                                                            (change)="controlOnChange($event)" />
                                                        {{web.service_name}}
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Vinoth Changes new deploy -->
                        <br /><br />

                        <div class="row">
                            <div class="col-12 text-center">
                                <button type="submit" name="find" class="btn btn-primary text-white"
                                    (click)="getAppointments()">
                                    SUMMARY
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>



    <div class="container-fluid wrapper-page" *ngIf="payloadInvoce" id="doctorarea">
        <div class="page-head">

        </div>
        <div class="card-body-1 table-responsive">
            <div class="">
                <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                    <div class="row">
                        <div class="col-sm-12">
                            <table id="datatable2" class="table dataTable no-footer" role="grid"
                                aria-describedby="datatable2_info">
                                <thead>
                                    <tr *ngIf="payloadInvoce && payloadInvoce?.length" align="center" role="row">
                                        <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-sort="ascending"
                                            aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                                            Date</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Position: activate to sort column ascending"
                                            style="width: 12.3%;">
                                            Patient Name</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Office: activate to sort column ascending"
                                            style="width: 12.3%">
                                            Service Name</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Office: activate to sort column ascending"
                                            style="width: 12.3%">
                                            Fees Collected</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr align="center" role="row" class="odd" *ngFor="let record of payloadInvoce">
                                        <td>{{record.c_date| date:'dd-MM-yyyy'}}</td>
                                        <td>{{record.first_name}} </td>
                                        <td>{{record.service_name}}</td>
                                        <td>{{record.scost}}</td>
                                    </tr>
                                    <hr>
                                    <tr align="center" role="row" class="odd"
                                        *ngIf="payloadInvoce && payloadInvoce?.length">
                                        <td></td>
                                        <td></td>
                                        <td class="text-dark font-weight-bold">TOTAL</td>
                                        <td class="text-dark font-weight-bold">{{totalamount}}</td>
                                    </tr>
                                    <!-- <tr align="center" *ngIf="payloadInvoce">
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <div class=" card m-b-30">
                                                <div>
                                                    <div class="row">
                                                        <h5 class="text-danger text-center"
                                                            *ngIf="payloadInvoce.length === 0">
                                                            No records found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>







</div>
<!-- 
<div class="container-fluid wrapper-page" id="doctorarea">
    <div class="page-head">

    </div>
    <div class="card-body-1 table-responsive">
        <div class="">
            <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                    <div class="col-sm-12">
                        <table id="datatable2" class="table dataTable no-footer" role="grid"
                            aria-describedby="datatable2_info">
                            <thead>
                                <tr *ngIf="payloadInvoce && payloadInvoce?.length" align="center" role="row">
                                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-sort="ascending"
                                        aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                                        Date</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                        aria-label="Position: activate to sort column ascending" style="width: 12.3%;">
                                        Patient Name</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                        aria-label="Office: activate to sort column ascending" style="width: 12.3%">
                                        Service Name</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                        aria-label="Office: activate to sort column ascending" style="width: 12.3%">
                                        Fees Collected</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr align="center" role="row" class="odd" *ngFor="let record of payloadInvoce">
                                    <td>{{record.c_date| date:'dd-MM-yyyy'}}</td>
                                    <td>{{record.first_name}} </td>
                                    <td>{{record.service_name}}</td>
                                    <td>{{record.scost}}</td>
                                </tr>
                                <hr>
                                <tr align="center" role="row" class="odd"
                                    *ngIf="payloadInvoce && payloadInvoce?.length">
                                    <td></td>
                                    <td></td>
                                    <td class="text-dark font-weight-bold">TOTAL</td>
                                    <td class="text-dark font-weight-bold">{{totalamount}}</td>
                                </tr>
                                <tr align="center" *ngIf="payloadInvoce">
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <div class=" card m-b-30">
                                            <div>
                                                <div class="row">
                                                    <h5 class="text-danger text-center"
                                                        *ngIf="payloadInvoce.length === 0">
                                                        No records found</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->